__turbopack_context__.v({
  "body": "dtImmW_body",
  "filmCard": "dtImmW_filmCard",
  "filmLayer": "dtImmW_filmLayer",
  "filmVideoFill": "dtImmW_filmVideoFill",
  "intro": "dtImmW_intro",
  "introStack": "dtImmW_introStack",
  "outer": "dtImmW_outer",
  "stage": "dtImmW_stage",
  "storePill": "dtImmW_storePill",
  "storeRow": "dtImmW_storeRow",
  "title": "dtImmW_title",
});
